export default "/images/f4dc48dc833e998f244e645a5b963994.avif";